import { render, staticRenderFns } from "./DataViewer.vue?vue&type=template&id=c4ef66f8&scoped=true&"
import script from "./DataViewer.vue?vue&type=script&lang=js&"
export * from "./DataViewer.vue?vue&type=script&lang=js&"
import style0 from "./DataViewer.vue?vue&type=style&index=0&id=c4ef66f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ef66f8",
  null
  
)

export default component.exports